<template>
  <div class="container">
    <div v-if="showMessage" class="text-center">
      <div>
        <img class="succes-item" src="../../assets/assets_loyalty/garrapata.png">
      </div>
      <div>
        <h2 class="title-modal-success">¡Listo!</h2>
      </div>
      <div>
        <p class="text-modal-success">Te hemos enviado un correo para validar tu cuenta</p>
      </div>
    </div>
    <div v-if="!showMessage" class="justify-content-center form-container">
      <div class="label-title row">
        <label>Nombre del comercio:</label>
      </div>
      <div class="row">
        <input id="name-commerce" class="input-item" type="text" v-model="nameCommerce">
      </div>
      <div class="label-title row">
        <label>Número de sucursales (max 2):</label>
      </div>
      <div class="row">
        <input id="branch-num" class="input-item" type="text" maxlength="1" v-model="branchOfficesNum">
      </div>
      <div class="label-title row">
        <label>E-mail:</label>
      </div>
      <div class="row">
        <input id="email" class="input-item" type="text" v-model="email">
      </div>
      <div class="label-title row">
        <label>Sitio Web:</label>
      </div>
      <div class="row">
        <input id="web-site" class="input-item" type="text" v-model="webSite">
      </div>
      <div class="label-title row">
        <label>Contraseña: (mínimo 5 caractes)</label>
      </div>
      <div class="row">
        <input id="password" class="input-item" type="password" v-model="password">
      </div>
      <div class="label-title row">
        <label>Repetir contraseña:</label>
      </div>
      <div class="row">
        <input id="password-review" class="input-item" type="password" v-model="passwordReview">
      </div>
      <div class="label-title row">
        <label>Nombre:</label>
      </div>
      <div class="row">
        <input id="name" class="input-item" type="text" v-model="name">
      </div>
      <div class="label-title row">
        <label>Apellidos:</label>
      </div>
      <div class="row">
        <input id="lastname" class="input-item" type="text" v-model="lastname">
      </div>
      <div class="label-title row">
        <label>Dirección:</label>
      </div>
      <div class="row">
        <input id="address" class="input-item" type="text" v-model="address">
      </div>
      <div class="label-title row">
        <label>Código postal:</label>
      </div>
      <div class="row">
        <input id="zip-code" class="input-item" type="text" maxlength="5" v-model="zipCode">
      </div>
      <div class="label-title row">
        <label>Telefono:</label>
      </div>
      <div class="row">
        <input id="phoneNumber" class="input-item" type="text" maxlength="10" v-model="phone">
      </div>
      <div class="row">
        <vue-recaptcha class="captchatNew" ref="recaptcha" @verify="markRecaptchaAsVerified" sitekey="6LdlXLwUAAAAAHouUjujMEM-7Ec4_Gz0RkDmS5Xv" :loadRecaptchaScript="true"></vue-recaptcha>
      </div>
      <div class="row">
        <input id="check-box" type="checkbox" class="check-box" v-model="checkBoxAcept"><a class="check-box-text" target="_blank" href="/privacidad">Acepto aviso de privacidad | </a><a class="check-box-text" target="_blank" href="/condiciones"> terminos y condiciones</a>
      </div>
      <div class="text-center">
        <div class="error-item">{{errorMessage}}</div>
      </div>
      <div v-if="showBotton" class="row">
        <button class=" btn-round check-in-button btn-style">
          <img class="loader-gif" src="../../../public/img/Rolling.gif">
        </button>
      </div>
      <div v-if="!showBotton" class="row">
        <button class="btn-success btn-round check-in-button btn-style" @click="contractButton()">Contratar Ahora</button>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import LoginService from '../../service/core/login.service';

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      loginService: new LoginService(),
      showMessage: false,
      showBotton: false,
      nameCommerce:'',
      branchOfficesNum:'',
      email:'',
      webSite:'',
      password:'',
      passwordReview:'',
      name:'',
      lastname:'',
      address:'',
      zipCode:'',
      state: '',
      phone:'',
      checkBoxAcept: false,
      captchatMarck: false,
      errorMessage:''
    }
  },
  methods:{
    markRecaptchaAsVerified(response) {
      this.captchatMarck = true;
    },
    restartValidation(){
      this.errorMessage = ''  
      document.getElementById("name-commerce").classList.remove("error-input")
      document.getElementById("branch-num").classList.remove("error-input")
      document.getElementById("email").classList.remove("error-input")
      document.getElementById("web-site").classList.remove("error-input")
      document.getElementById("password").classList.remove("error-input")
      document.getElementById("password-review").classList.remove("error-input")
      document.getElementById("name").classList.remove("error-input")
      document.getElementById("password-review").classList.remove("error-input")
      document.getElementById("lastname").classList.remove("error-input")
      document.getElementById("address").classList.remove("error-input")
      document.getElementById("zip-code").classList.remove("error-input")
      document.getElementById("check-box").classList.remove("error-input")
      document.getElementById("phoneNumber").classList.remove("error-input")
    },
    validEmail(email){
      let re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      return re.test(email)
    },
    validNumbers(str){
      let re = new RegExp(/^([0-9])*$/)
      return re.test(str)
    },
    contractButton(){
      this.restartValidation()
      this.showBotton = true
      if(this.nameCommerce == ''){
        document.getElementById("name-commerce").classList.add("error-input")
        this.errorMessage = 'El nombre del comercio es obligatorio'  
        this.showBotton = false
      }
      if(this.branchOfficesNum == ''){
        this.showBotton = false
        document.getElementById("branch-num").classList.add("error-input")
        this.errorMessage = 'El número de sucursales es obligatorio'
      }else if(!this.validNumbers(this.branchOfficesNum)){
        this.showBotton = false
        document.getElementById("branch-num").classList.add("error-input")
        this.errorMessage = 'El número de sucursales se debe ingresar con número en vez de texto.'
      }else if(Number(this.branchOfficesNum) > 2){
        this.showBotton = false
        document.getElementById("branch-num").classList.add("error-input")
        this.errorMessage = 'El número máximo de sucursales para la versión de prueba es de 2'
      }
      if(this.email == ''){
        this.showBotton = false
        document.getElementById("email").classList.add("error-input")
        this.errorMessage = 'El email es obligatorio'
      }else{
        if(!this.validEmail(this.email)){
          this.showBotton = false
          document.getElementById("email").classList.add("error-input")
          this.errorMessage = 'El email no es un correo válido'
        }
      }
      if(this.webSite == ''){
        this.showBotton = false
        document.getElementById("web-site").classList.add("error-input")
        this.errorMessage = 'El sitio web es obligatorio'
      }
      if(this.password == '' || this.password.length < 5){
        this.showBotton = false
        document.getElementById("password").classList.add("error-input")
        this.errorMessage = 'La contraseña es obligatoria y debe ser mayor a 5 caracteres'
      }
      if(this.passwordReview == ''){
        this.showBotton = false
        document.getElementById("password-review").classList.add("error-input")
        this.errorMessage = 'Las contraseñas no coinciden'
      }
      if(this.passwordReview !== this.password){
        this.showBotton = false
        document.getElementById("password-review").classList.add("error-input")
        this.errorMessage = 'Las contraseñas no coinciden'
      }
      if(this.name == ''){
        this.showBotton = false
        document.getElementById("name").classList.add("error-input")
        this.errorMessage = 'Tu nombre es obligatorio'
      }
      if(this.lastname == ''){
        this.showBotton = false
        document.getElementById("lastname").classList.add("error-input")
        this.errorMessage = 'Tu apellido es obligatorio'
      }
      if(this.address == ''){
        this.showBotton = false
        document.getElementById("address").classList.add("error-input")
        this.errorMessage = 'Ingresa la dirección de tu negocio.'
      }
      if(this.zipCode == ''){
        this.showBotton = false
        document.getElementById("zip-code").classList.add("error-input")
        this.errorMessage = 'Ingresa el codigo postal de tu negocio.'
      }else{
        if(!this.validNumbers(this.zipCode)){
          this.showBotton = false
          document.getElementById("zip-code").classList.add("error-input")
          this.errorMessage = 'El código postal solo debe contener números'
        }
      }
      if(this.phone == ''){
        this.showBotton = false
        document.getElementById("phoneNumber").classList.add("error-input")
        this.errorMessage = 'Ingresa un número de teléfono de contacto.'
      }else{
        if(!this.validNumbers(this.phone)){
          this.showBotton = false
          document.getElementById("phoneNumber").classList.add("error-input")
          this.errorMessage = 'Ingresa un número de teléfono válido.'
        }
      }
      if(this.checkBoxAcept == false){
        this.showBotton = false
        document.getElementById("check-box").classList.add("error-input")
        this.errorMessage = 'Por favor acepta el aviso de privacidad y los términos y condicones'
      }
      if(this.captchatMarck == false){
        this.showBotton = false
        this.errorMessage = 'Marcar Captcha';
      }

      if(this.errorMessage.length == 0){
        let conditions = {
          "merchant": {
            "merchant_name": this.nameCommerce,
            "offices": this.branchOfficesNum,
            "email": this.email,
            "web_site": this.webSite,
            "password": this.password,
            "name": this.name,
            "lastname": this.lastname,
            "address": this.address,
            "zip_code": this.zipCode,
            "phone": this.phone,
          }
        }
        this.loginService.registryNewCommerce(conditions).then(data => {
          this.showBotton = false
          this.showMessage = true
        }, error => {
          this.showBotton = false
          let errorCatch = error['message']
          if(errorCatch.includes('402')){
            this.errorMessage = 'Es necesario que capture un correo o un teléfono valido para el registro';
          } else if(errorCatch.includes('403')){
            this.errorMessage = 'El correo capturado ya existe, ingresa uno diferente.';
          } else if(errorCatch.includes('404')){
            this.errorMessage = 'Ingrese un codigo postal valido';
          }else{
            this.errorMessage = 'Tuvimos un error al registrar tu comercio, intentalo mas tarde'
          }
        })
      }else{
         this.showBotton = false
      }
      
    }
  }
};
</script>
<style lang="scss">
.label-title{
  color: rgb(172, 172, 172);
  font-size: 13px;
  padding: 0px;
}

.input-item{
  width: 100%;
  margin-top: -10px;
  padding: 0px;
  margin-bottom: 10px;
  border: 1px;
  border-bottom: 2px solid rgba(167, 167, 167, 0.507);
}
.check-box{
  margin-right: 10px;
}

.check-box-text{
  color: #00bbff
}
.form-container{
  padding: 10px;
}

.btn-style{
  margin-top:20px;  
}

.error-item{
  color:red;
}

.error-input{
  -webkit-box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
  -moz-box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
  box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
}

.succes-item{
  width: 100px;
}

.title-modal-success{
  margin: 15px;
  color: #00bbff;
  font-weight: bold;
}

.text-modal-success{
  color: #00bbff;
  font-weight: bold;
}

.loader-gif{
  width: 30px;
}

</style>
